<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pvi"></a><a class="page" id="pvii"></a>Contents</h1>
<p class="tocfmf"><a class="xref" href="#/chijacobson0007#lot">List of Tables</a></p>
<p class="tocfm"><a class="xref" href="#/chijacobson0008#loi">List of Figures</a></p>
<p class="tocfm"><a class="xref" href="#/chijacobson0009#pref">Preface</a></p>
<p class="tocf"><a class="xref" href="#/chijacobson0010#ch01"><span class="sm">ONE</span>  /  Introduction</a></p>
<p class="toc"><a class="xref" href="#/chijacobson0011#ch02"><span class="sm">TWO</span>  /  The Coevolution of Affect toward Presidents and Parties</a></p>
<p class="toc"><a class="xref" href="#/chijacobson0012#ch03"><span class="sm">THREE</span>  /  Evaluations of Parties and Party Leaders</a></p>
<p class="toc"><a class="xref" href="#/chijacobson0013#ch04"><span class="sm">FOUR</span>  /  Assessments of Party Competence</a></p>
<p class="toc"><a class="xref" href="#/chijacobson0014#ch05"><span class="sm">FIVE</span>  /  Cognitive Views of Parties</a></p>
<p class="toc"><a class="xref" href="#/chijacobson0015#ch06"><span class="sm">SIX</span>  /  Party Identification I: Partisan Change</a></p>
<p class="toc"><a class="xref" href="#/chijacobson0016#ch07"><span class="sm">SEVEN</span>  /  Party Identification II: Generational Imprinting</a></p>
<p class="toc"><a class="xref" href="#/chijacobson0017#ch08"><span class="sm">EIGHT</span>  /  Elections</a></p>
<p class="toc"><a class="xref" href="#/chijacobson0018#ch09"><span class="sm">NINE</span>  /  Polarized Parties, the 2016 Elections, and the Early Trump Presidency</a></p>
<p class="toc"><a class="xref" href="#/chijacobson0019#ch10"><span class="sm">TEN</span>  /  Conclusion</a></p>
<p class="tocbmf"><a class="xref" href="#/chijacobson0020#app">Appendix: Data Sources</a></p>
<p class="tocbm"><a class="xref" href="#/chijacobson0021#refs">References</a></p>
<p class="tocbm"><a class="xref" href="#/chijacobson0022#index">Index</a></p>
<p class="tocbm"><a class="xref" href="#/chijacobson0023#fn_notes">Footnotes</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-jacobson-0006.vue?3fe6082f